import React from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import { deleteListener, listOctaviaPools } from './actions'
import Modal from 'core/elements/modal'
import useListAction from 'core/hooks/useListAction'
import { useAppSelector } from 'app/store'
import { octaviaPoolsSelector } from './selectors'
import { makeStyles } from '@material-ui/styles'
import Theme from 'core/themes/model'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import clsx from 'clsx'
import DeleteDialog from 'core/components/DeleteDialog'

export default function DeleteListenersDialog({ rows, onClose }) {
  const classes = useStyles()
  useListAction(listOctaviaPools)
  const poolDetails = useAppSelector(octaviaPoolsSelector)
  const associatedListeners = rows?.filter((row) =>
    poolDetails?.some((detail) => detail?.listeners?.[0]?.id === row?.id),
  )

  const isListenerAssociated = associatedListeners?.length > 0
  const associatedListenerNames = associatedListeners?.map((row) => row?.name).join(', ')

  if (isListenerAssociated) {
    return (
      <Modal
        panel="dialog"
        open
        onClose={onClose}
        title={
          <div className={classes.root}>
            <FontAwesomeIcon solid className={clsx(classes.circleIcon, classes.circleError)}>
              circle-xmark
            </FontAwesomeIcon>
            <div className={classes.header}>Delete Listener</div>
          </div>
        }
        footer={
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
        }
      >
        <Text variant="body2">
          You cannot delete the following Listener(s) because they are associated with a Pool(s).
          Please delete the associated Pool(s) first.
          <br />
          <strong>{associatedListenerNames}</strong>
        </Text>
      </Modal>
    )
  }

  return (
    <DeleteDialog
      rows={rows}
      onClose={onClose}
      deleteAction={deleteListener}
      title="Delete Listener(s)"
      resourceLabel="Listeners"
    />
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    paddingLeft: theme.spacing(1),
  },
  root: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  circleIcon: {
    fontSize: '18px',
    color: '#fff',
  },
  circleError: {
    background: theme.palette.graphRed[100],
    color: theme.palette.graphRed[500],
  },
}))
